import { Link } from "react-router-dom";
import blog10 from "assets/images/all-img/blog2/dark/blog10.png";
import blog11 from "assets/images/all-img/blog2/dark/blog11.png";
import blog12 from "assets/images/all-img/blog2/dark/blog12.png";
import blog14 from "assets/images/all-img/blog2/dark/blog14.png";
import blog7 from "assets/images/all-img/blog2/dark/blog7.png";
import blog8 from "assets/images/all-img/blog2/dark/blog8.png";
import blog9 from "assets/images/all-img/blog2/dark/blog9.png";
import blog13 from "assets/images/all-img/blog2/dark/blog12.png";
import arrowRightWhite from "assets/images/svg2/arrow-right-white.svg";
 
export default function BlogPostSection() {
	return (
		<div className="row">
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay="0s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog14} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>What does the NFT Ecosystem look like after the Boom?</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".10s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog7} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>Mekaverse Launch: Let’s take a step back with data!</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".20s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog8} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>We’ve valued one of the best NFT portfolios in the world!</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".30s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog9} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>The distribution of players on blockchain gaming</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".40s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog10} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>Celebrities and NFTs: what’s all the hype about?</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".50s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog11} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>What’s coming next after the rescue of the MoonCats?</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".60s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog12} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>The Matrix NFT Avatars are coming to Nifty’s!</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
			<div className="col-md-6">
				<div className="fugu--blog-wrap fugu--blog-wrap2 wow fadeInUpX" data-wow-delay=".70s">
					<div className="fugu--blog-thumb">
						<Link to={"/single-blog-light"}>
							<img src={blog13} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to={"#"}>Art & Analusis</Link>
								</li>
								<li>
									<Link to={"#"}>July 18, 2022</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"/single-blog-light"}>
								<h3>Our NFT Market Report Q1 2022 is published</h3>
							</Link>
						</div>
						<Link to={"single-blog-light"}  >
							<a className="fugu--readmore-btn" href="single-blog.html">
								Read more
								<span>
									<img src={arrowRightWhite} alt="" />
								</span>
							</a>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
